import axios from "axios";

class AppService {
  getAppData() {
    return axios.post('/app/appdata.php');
  }

  checkLogin() {
    return axios.post('/app/logincheck.php');
  }

}

export default new AppService();
